import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import DateColumn from "@isceco/widget-library2/basic-elements/List/column/DateColumn.js";
import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import OptionalButtonCell from "../../components/StaticDetailList/OptionalButtonCell";

export default class ZVVMitgliederColumns {

  static getColumns(isKi) {
    const roles = new AuthorizationFilter().roles
    if (roles.GP_SUPERUSER && isKi) {
      return [
        ZVVMitgliederColumns.NAME_COLUMN(),
        ZVVMitgliederColumns.ADRESSE_COLUMN(),
        ZVVMitgliederColumns.KANTON_COLUMN(),
        ZVVMitgliederColumns.VNB_COLUMN(),
        ZVVMitgliederColumns.KI_COLUMN(),
        ZVVMitgliederColumns.BEITRITT_COLUMN(),
        ZVVMitgliederColumns.AUSTRITT_COLUMN(),
        ZVVMitgliederColumns.ENTFERNEN_COLUMN()
      ]
    } else {
      return [
        ZVVMitgliederColumns.NAME_COLUMN(),
        ZVVMitgliederColumns.ADRESSE_COLUMN(),
        ZVVMitgliederColumns.KANTON_COLUMN(),
        ZVVMitgliederColumns.VNB_COLUMN(),
        ZVVMitgliederColumns.KI_COLUMN(),
        ZVVMitgliederColumns.BEITRITT_COLUMN(),
        ZVVMitgliederColumns.AUSTRITT_COLUMN()
      ]
    }
  }

  static getRowVariant() {
    return {
      get(row) {
        if (row.austrittsdatum) {
          return 'error'
        }
        return ''
      }
    }
  }

  static NAME_COLUMN() {
    return new StringColumn({
      key: 'name',
      text: 'zvv.mitglieder.table.header.name',
    })
  }

  static ADRESSE_COLUMN() {
    return new StringColumn({
      key: 'adresse',
      text: 'zvv.mitglieder.table.header.adresse',
    })
  }

  static KANTON_COLUMN() {
    return new StringColumn({
      key: 'kanton',
      text: 'zvv.mitglieder.table.header.kanton',
    })
  }

  static VNB_COLUMN() {
    return new StringColumn({
      key: 'verteilnetzbetreiberName',
      text: 'zvv.mitglieder.table.header.vnb',
    })
  }

  static KI_COLUMN() {
    return new StringColumn({
      key: 'ki',
      text: 'zvv.mitglieder.table.header.ki',
      translate: true
    })
  }

  static BEITRITT_COLUMN() {
    return new DateColumn({
      key: 'beitrittsdatum',
      text: 'zvv.mitglieder.table.header.beitritt',
    })
  }

  static AUSTRITT_COLUMN() {
    return new DateColumn({
      key: 'austrittsdatum',
      text: 'zvv.mitglieder.table.header.austritt',
    })
  }

  static ENTFERNEN_COLUMN() {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new OptionalButtonCell({
        icon: 'trash alternate outline',
        variant: 'danger',
        show: row => (!row.isKi && !row.austrittsdatum),
      })
    })
  }
}
